import React from "react";
import { Link } from "react-router-dom";
import Button from "../Components/CustomButtons/Button";
import Grid from "@material-ui/core/Grid";
import Footer from '../Components/Footer/Footer';
import "./Resume.css";
const Result = () => {
	return (
		<div className="container" style={{ color: "white" }}>
			<h3 style={{ textAlign: "center", fontSize: 80 }}>Resume</h3>
			<h6 style={{ textAlign: "center", fontSize: 20 }}>
				{" "}
				<Link to="/">Home</Link> <span style={{ marginLeft: 20 }}> / </span>{" "}
				<span style={{ marginLeft: 20 }}> Resume </span>
			</h6>
			<Grid item xs={10} md={10} lg={6} style={{ float: "left" }}>
				<div className="resume-section">
					<div class="subheading">
						<h3>Education</h3>
					</div>
					<ul class="education">
						<li>
							<span class="line-left"></span>
							<div class="content">
								<h4>
									International Institute of Professional Studies,DAVV,Indore
								</h4>
								<h5>Master of Computer Application</h5>
							</div>
							<span class="year">
								<span class="to">Ongoing</span>
								<span class="from">2019</span>
							</span>
						</li>
						<li>
							<span class="line-left"></span>
							<div class="content">
								<h4>
									International Institute of Professional Studies,DAVV,Indore
								</h4>
								<h5>Bachelor of Computer Application</h5>
							</div>
							<span class="year">
								<span class="to">2019</span>
								<span class="from">2016</span>
							</span>
						</li>
						<li>
							<span class="line-left"></span>
							<div class="content">
								<h4>Devi Ahilya Govt. Excellence H.S.S. No. 1 Khagone</h4>
								<h5>High School</h5>
							</div>
							<span class="year">
								<span class="to">2015</span>
								<span class="from">2011</span>
							</span>
						</li>
					</ul>
				</div>
			</Grid>
			<Grid item xs={12} md={12} lg={6} style={{ float: "left" }}>
				<div>
					<h3 className="subheading">Skills</h3>
					<div>
						<h5 className="list-heading">Web Technologies</h5>
						<ul class="list-inline list-icons">
							<li class="list-inline-item">
								<Button
									href="https://www.w3.org/TR/html5/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className=" fab fa-html5" />
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://www.w3.org/standards/techs/css#w3c_all"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className=" fab fa-css3" />
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="http://sass-lang.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="fab fa-sass"></i>
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://materializecss.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="devicons devicons-materializecss"></i>
								</Button>
							</li>
						</ul>
						<h5 className="list-heading">Programming Languages</h5>
						<ul class="list-inline list-icons">
							<li class="list-inline-item">
								<Button
									href="https://www.javascript.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className=" fab fa-js" />
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://www.python.org/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className=" fab fa-python" />
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://www.java.com/en/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="fab fa-java"></i>
								</Button>
							</li>
						</ul>
                        <h5 className="list-heading">Frameworks and Libraries</h5>
						<ul class="list-inline list-icons">
							<li class="list-inline-item">
								<Button
									href="https://reactjs.org/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className=" fab fa-react" />
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://nodejs.org/en/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className=" fab fa-node-js" />
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://www.djangoproject.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i class="devicons devicons-django"></i>
								</Button>
							</li>
						</ul>
                        <h5 className="list-heading">Databases</h5>
						<ul class="list-inline list-icons">
							<li class="list-inline-item">
								<Button
									href="https://www.postgresql.org/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="devicons devicons-postgresql"/>
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://www.mysql.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="devicons devicons-mysql"/>
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://www.mongodb.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i class="devicons devicons-mongodb"></i>
								</Button>
							</li>
						</ul>
                        <h5 className="list-heading">Tools</h5>
						<ul class="list-inline list-icons">
							<li class="list-inline-item">
								<Button
									href="https://code.visualstudio.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="devicons devicons-visualstudio"/>
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://git-scm.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i className="devicons devicons-git"/>
								</Button>
							</li>
							<li class="list-inline-item">
								<Button
									href="https://github.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i class="fab fa-github"></i>
								</Button>
							</li>
                            <li class="list-inline-item">
								<Button
									href="https://classic.yarnpkg.com/en/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i class="fab fa-yarn"></i>
								</Button>
							</li>
                            <li class="list-inline-item">
								<Button
									href="https://www.npmjs.com/"
									target="_blank"
									color="transparent"
									className="button"
								>
									<i class="devicons devicons-npm"></i>
								</Button>
							</li>
						</ul>
					</div>
				</div>
			</Grid>
			<div style={{ clear: "both" }}>

            </div>
            <div style={{margin:20}}>
                &nbsp;
            </div>
			<Footer/>
		</div>
	);
};
export default Result;
